import axios from "axios";

const api = axios.create({
    baseURL: `${window.location.origin}/api`,
});

export default api;


// import axios from "axios";

// const api = axios.create({
//     baseURL: "https://uaediscountedhotels.com/api",
// });

// export default api;